/* CYGNUSS 2026-10-09: cupons do tema (Tema > Cupons Cygnuss) no balao do Resgatar cupons (pagina do produto).
   - Aplicar ativa o cupom na Shopify (/cart/update.js), como o campo de cupom do carrinho.
   - Com itens no carrinho: se o codigo nao vale, o cartao mostra "Finalizado" e o codigo sai do carrinho.
   - Carrinho vazio: o codigo fica guardado no carrinho e e conferido quando a cliente adiciona o produto.
   - O que ja esta ativo no carrinho (cupom ou desconto automatico, como o OUTUBRO25) vem primeiro no balao.
   - O balao fecha sozinho depois de 8 s parado, logo depois de ativar e quando a pagina rola um terco da tela. */
import { DiscountUpdateEvent, ThemeEvents } from '@theme/events';

if (!window.__cygCupons) {
  window.__cygCupons = true;

  const PARADO_MS = 8000;
  const DEPOIS_DE_ATIVAR_MS = 1200;
  const GUARDADO = 'cyg-cupom-resgatado';

  const postar = (url, body) =>
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then((r) => r.json());
  const carrinho = () => fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
  const lerGuardado = () => {
    try { return localStorage.getItem(GUARDADO) || ''; } catch (e) { return ''; }
  };
  const guardar = (codigo) => {
    try { codigo ? localStorage.setItem(GUARDADO, codigo) : localStorage.removeItem(GUARDADO); } catch (e) {}
  };
  const codigosDo = (c) => (c.discount_codes || []).map((d) => d.code);

  /* cupons que nao valeram nesta visita: o cartao continua dizendo Finalizado mesmo depois de redesenhar */
  const FIM = 'cyg-cupons-fim';
  const lerFim = () => { try { return JSON.parse(sessionStorage.getItem(FIM) || '[]'); } catch (e) { return []; } };
  const marcarFim = (codigo) => {
    try { const l = lerFim(); if (!l.includes(codigo)) { l.push(codigo); sessionStorage.setItem(FIM, JSON.stringify(l)); } } catch (e) {}
  };

  /* estado da pilula: '' (Resgatar cupons), 'on' (ativo), 'guardado' (resgatado, carrinho vazio), 'fim' (oferta finalizada).
     Codigo comprido (mais de 11 letras) aparece sem a palavra do estado para nao cortar (igual ao Liquid do cyg-cupons). */
  function pilula(estado, codigo) {
    const curto = codigo && codigo.length <= 11;
    document.querySelectorAll('.cyg-cupons__pill').forEach((p) => {
      p.classList.toggle('is-on', estado === 'on' || estado === 'guardado');
      p.classList.toggle('is-fim', estado === 'fim');
      if (estado === 'on' || estado === 'guardado') p.setAttribute('aria-label', 'Cupom ' + codigo + (estado === 'on' ? ' ativo' : ' resgatado'));
      else p.removeAttribute('aria-label');
      const t = p.querySelector('[data-cyg-cupons-txt]');
      if (!t) return;
      t.textContent =
        estado === 'on' ? (curto ? codigo + ' ativo' : codigo)
        : estado === 'guardado' ? (curto ? codigo + ' resgatado' : codigo)
        : estado === 'fim' ? 'Oferta finalizada'
        : 'Resgatar cupons';
    });
  }

  /* estado do cartao: '' | 'carregando' | 'on' | 'guardado' | 'fim' */
  function cartao(codigo, estado) {
    document.querySelectorAll('[data-cyg-cupom-card]').forEach((c) => {
      if (c.dataset.cygCupomCard !== codigo) return;
      c.classList.remove('is-on', 'is-guardado', 'is-fim', 'is-carregando');
      if (estado) c.classList.add('is-' + estado);
      const b = c.querySelector('[data-cyg-cupom]');
      if (b) b.disabled = !!estado;
    });
  }

  const fecharDepois = (balao, ms) => {
    if (!balao) return;
    setTimeout(() => { if (balao.matches(':popover-open')) balao.hidePopover(); }, ms);
  };

  async function aplicar(codigo, balao) {
    cartao(codigo, 'carregando');
    try {
      const atual = await carrinho();
      const outros = codigosDo(atual).filter((c) => c.toUpperCase() !== codigo);
      const novo = await postar('/cart/update.js', { discount: [...outros, codigo].join(',') });
      const d = (novo.discount_codes || []).find((x) => x.code.toUpperCase() === codigo);
      if (novo.item_count > 0) {
        if (d && d.applicable) {
          cartao(codigo, 'on');
          pilula('on', codigo);
          guardar('');
          document.dispatchEvent(new DiscountUpdateEvent(novo, 'cyg-cupons'));
          fecharDepois(balao, DEPOIS_DE_ATIVAR_MS);
        } else {
          cartao(codigo, 'fim');
          marcarFim(codigo);
          await postar('/cart/update.js', { discount: outros.join(',') });
        }
      } else {
        /* carrinho vazio: a Shopify guarda o codigo no carrinho e confere quando entrar o produto */
        cartao(codigo, 'guardado');
        pilula('guardado', codigo);
        guardar(codigo);
        fecharDepois(balao, DEPOIS_DE_ATIVAR_MS);
      }
    } catch (e) {
      cartao(codigo, '');
    }
  }

  /* depois que a cliente adiciona o produto, confere o cupom guardado */
  async function conferirGuardado() {
    const codigo = lerGuardado();
    if (!codigo) return;
    const c = await carrinho();
    if (!c.item_count) return pilula('guardado', codigo);
    const d = (c.discount_codes || []).find((x) => x.code.toUpperCase() === codigo);
    guardar('');
    if (d && d.applicable) {
      pilula('on', codigo);
      cartao(codigo, 'on');
      return;
    }
    if (d) await postar('/cart/update.js', { discount: codigosDo(c).filter((x) => x.toUpperCase() !== codigo).join(',') });
    cartao(codigo, 'fim');
    marcarFim(codigo);
    pilula('fim');
    setTimeout(() => pilula(''), 4000);
  }

  document.addEventListener('click', (e) => {
    const bt = e.target.closest && e.target.closest('[data-cyg-cupom]');
    if (!bt || bt.disabled) return;
    aplicar(bt.dataset.cygCupom, bt.closest('.cyg-cupons__balao'));
  });
  function sincroniza(cart) {
    const ativos = (cart.discount_codes || []).filter((d) => d.applicable).map((d) => d.code.toUpperCase());
    const cods = [...new Set([...document.querySelectorAll('[data-cyg-cupom-card]')].map((c) => c.dataset.cygCupomCard))];
    cods.forEach((cod) => {
      const c = document.querySelector(`[data-cyg-cupom-card="${CSS.escape(cod)}"]`);
      if (ativos.includes(cod)) { if (!c.classList.contains('is-on')) cartao(cod, 'on'); }
      else if (c.classList.contains('is-on')) cartao(cod, '');
    });
    estadoPilula(cart);
  }
  const aplicaFim = () => lerFim().forEach((cod) => cartao(cod, 'fim'));

  /* o que esta ativo no carrinho, na ordem do carrinho: descontos do pedido, dos itens e cupons digitados */
  function descontosAtivos(c) {
    const lista = [], vistos = new Set();
    const junta = (app) => {
      const cod = String((app && app.title) || '').trim().toUpperCase();
      if (!cod || vistos.has(cod)) return;
      vistos.add(cod);
      lista.push({ cod, app });
    };
    (c.cart_level_discount_applications || []).forEach(junta);
    (c.items || []).forEach((i) => (i.line_level_discount_allocations || []).forEach((a) => junta(a.discount_application)));
    (c.discount_codes || []).filter((d) => d.applicable).forEach((d) => junta({ title: d.code }));
    return lista;
  }
  /* o valor fixo vem em reais (25.0 = R$ 25), na API do carrinho e no Liquid */
  const valorDe = (app) => {
    const v = parseFloat(app && app.value);
    if (!isFinite(v)) return '';
    if (app.value_type === 'percentage') return String(Math.round(v * 10) / 10).replace('.', ',') + '%';
    return 'R$ ' + (Number.isInteger(v) ? String(v) : v.toFixed(2).replace('.', ','));
  };
  /* balao: ativos primeiro; desconto de fora do tema que ficou ativo ganha um cartao pelo molde; o que deixou de valer sai */
  function ordenaBalao(c) {
    const ativos = descontosAtivos(c), cods = ativos.map((a) => a.cod);
    document.querySelectorAll('.cyg-cupons__lista').forEach((lista) => {
      lista.querySelectorAll('[data-cyg-cupom-extra]').forEach((el) => { if (!cods.includes(el.dataset.cygCupomCard)) el.remove(); });
      const modelo = lista.parentElement && lista.parentElement.querySelector('template[data-cyg-cupom-modelo]');
      ativos.slice().reverse().forEach(({ cod, app }) => {
        let card = lista.querySelector(`[data-cyg-cupom-card="${CSS.escape(cod)}"]`);
        if (!card && modelo && modelo.content.firstElementChild) {
          card = modelo.content.firstElementChild.cloneNode(true);
          card.dataset.cygCupomCard = cod;
          const val = card.querySelector('.cyg-cupom__val'), cdg = card.querySelector('.cyg-cupom__txt b'), bt = card.querySelector('[data-cyg-cupom]');
          const v = valorDe(app);
          if (val) { val.textContent = v; if (/%|R\$/.test(v)) { const off = document.createElement('small'); off.textContent = 'OFF'; val.appendChild(off); } }
          if (cdg) cdg.textContent = cod;
          if (bt) bt.dataset.cygCupom = cod;
        }
        if (card && lista.firstElementChild !== card) lista.prepend(card);
      });
    });
  }
  /* a pilula acende com o primeiro desconto ativo do carrinho, o mesmo que abre a lista do balao (cupom do tema,
     codigo de fora do tema como o OUTUBRO25 ou desconto automatico). Antes so os cupons do tema acendiam (12/10/2026). */
  function estadoPilula(c) {
    if ([...document.querySelectorAll('.cyg-cupons__pill')].some((p) => p.classList.contains('is-fim'))) return; /* aviso de 4 s */
    const ativo = descontosAtivos(c)[0];
    const guardado = lerGuardado();
    if (ativo) pilula('on', ativo.cod);
    else if (guardado && !c.item_count) pilula('guardado', guardado);
    else pilula('');
  }
  let pedidoBalao = 0;
  const atualizaBalao = () => {
    if (!document.querySelector('.cyg-cupons__lista')) return;
    const n = ++pedidoBalao;
    carrinho().then((c) => { if (n === pedidoBalao) { ordenaBalao(c); estadoPilula(c); } }).catch(() => {});
  };
  /* voltou pela seta do navegador com a pagina guardada: confere o carrinho de novo */
  window.addEventListener('pageshow', (e) => { if (e.persisted) atualizaBalao(); });
  document.addEventListener(ThemeEvents.discountUpdate, (e) => { const r = e.detail && e.detail.resource; if (r && r.discount_codes) sincroniza(r); atualizaBalao(); });
  document.addEventListener(ThemeEvents.cartUpdate, () => { conferirGuardado(); setTimeout(aplicaFim, 60); atualizaBalao(); });

  /* balao: logo abaixo da pilula, na largura da linha de compra, e rola junto com a pagina (posicao em relacao a
     pagina, nao a tela); seta apontando para o meio da pilula; fecha sozinho depois de um tempo parado */
  document.querySelectorAll('.cyg-cupons__balao').forEach((balao) => {
    let relogio = null;
    const arma = () => {
      clearTimeout(relogio);
      relogio = setTimeout(() => { if (balao.matches(':popover-open')) balao.hidePopover(); }, PARADO_MS);
    };
    const posiciona = () => {
      const pill = balao.closest('.cyg-cupons')?.querySelector('.cyg-cupons__pill');
      const linha = balao.closest('.product-form-buttons') || balao.closest('.cyg-cupons');
      if (!pill || !linha) return;
      const p = pill.getBoundingClientRect();
      const l = linha.getBoundingClientRect();
      balao.style.setProperty('--cyg-b-top', Math.round(p.bottom + window.scrollY + 10) + 'px');
      balao.style.setProperty('--cyg-b-left', Math.round(l.left + window.scrollX) + 'px');
      balao.style.setProperty('--cyg-b-w', Math.round(l.width) + 'px');
      balao.style.setProperty('--cyg-seta', Math.round(p.left + p.width / 2 - l.left - 6) + 'px');
    };
    /* rolou um terco da tela desde que abriu: fecha (pedido do Guifa, 09/10/2026) */
    let yAbriu = 0;
    const longe = () => { if (balao.matches(':popover-open') && Math.abs(window.scrollY - yAbriu) > window.innerHeight * 0.3) balao.hidePopover(); };
    balao.addEventListener('beforetoggle', (e) => { if (e.newState === 'open') posiciona(); });
    balao.addEventListener('toggle', (e) => {
      if (e.newState !== 'open') { clearTimeout(relogio); window.removeEventListener('scroll', longe); return; }
      yAbriu = window.scrollY;
      posiciona();
      arma();
      window.addEventListener('scroll', longe, { passive: true });
    });
    window.addEventListener('resize', () => { if (balao.matches(':popover-open')) posiciona(); }, { passive: true });
    ['pointerdown', 'keydown', 'focusin'].forEach((ev) => balao.addEventListener(ev, arma, { passive: true }));
  });

  aplicaFim();
  if (lerGuardado()) conferirGuardado();
}
